export default __webpack_public_path__ + "static/media/clipart1236792.bcfde3a4.png";